import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./playbackProgressText/PlaybackProgressText.css";

function formatTime(value) {
  return `${Math.floor(value / 1000 / 60)}:${Math.floor((value / 1000) % 60)
    .toString()
    .padStart(2, "0")}`;
}

export function PlaybackProgressText(props) {
  return (
    <div
      className={classnames(
        styles.root,
        "font-size--button--small font-style--button-3",
      )}
      data-testid="playback progress text"
    >
      <span className={styles.timeNow}>{formatTime(props.time)}</span>
      {" / "}
      {formatTime(props.duration)}
    </div>
  );
}

PlaybackProgressText.propTypes = {
  duration: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired,
};
